'use client';

import styled from 'styled-components';
import { FieldError } from 'react-hook-form';
import React from 'react';


const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const StyledInput = styled.input<{ $hasError: boolean }>`
    padding: 10px 12px;
    border: 1px solid ${({ $hasError }) => ($hasError ? '#dc3545' : '#ced4da')};
    border-radius: 6px;
    font-size: 16px;

    &:focus {
        outline: none;
        border-color: ${({ $hasError }) => ($hasError ? '#dc3545' : '#80bdff')};
        box-shadow: ${({ $hasError }) =>
  $hasError ? '0 0 0 0.2rem rgba(220,53,69,.25)' : '0 0 0 0.2rem rgba(0,123,255,.25)'};
    }
`;

const ErrorText = styled.span`
  color: #dc3545;
  font-size: 14px;
  margin-top: 4px;
`;

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: FieldError;
}

export default function Input({ error, ...props }: InputProps) {
  return (
    <InputWrapper>
      <StyledInput $hasError={!!error} {...props} />
      {error && <ErrorText>{error.message}</ErrorText>}
    </InputWrapper>
  );
}
